'use strict';

/**
 * Default anesthetistic indicator values indexed by letter code.
 * Used for anesthesia billing calculations.
 *
 * @type {Object.<string, number>}
 */
const AnesthetisticIndicatorDefault = {
  'A': 128,
  'B': 150,
  'C': 180,
  'D': 220,
  'E': 250,
  'F': 280,
  'G': 320,
  'H': 350,
  'I': 400,
  'J': 450,
  'K': 500,
  'L': 550,
  'M': 600,
  'N': 650,
  'P': 700,
  'Q': 750,
  'R': 850,
  'S': 950,
  'T': 1150,
  'U': 1300,
  'V': 1500,
  'W': 1700,
  'X': 1935,
  'Y': 2380,
  'Z': 2670
};

/**
 * Ordered list of valid anesthetistic indicator letter codes.
 *
 * @type {string[]}
 */
const AnesthetisticIndicatorLeters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

/**
 * Verifica se a configuracao de equipe por procedimento esta habilitada
 * para o convenio do evento.
 *
 * @param {Object|null|undefined} event
 * @param {Object} [event.healthInsurance]
 * @param {Object} [event.healthInsurance.flags]
 * @param {boolean} [event.healthInsurance.flags.enablePerProcedureTeam]
 * @returns {boolean} true se a feature esta habilitada, false caso contrario
 */
function isPerProcedureTeamEnabled(event) {
  return event?.healthInsurance?.flags?.enablePerProcedureTeam === true;
}

exports.AnesthetisticIndicatorDefault = AnesthetisticIndicatorDefault;
exports.AnesthetisticIndicatorLeters = AnesthetisticIndicatorLeters;
exports.isPerProcedureTeamEnabled = isPerProcedureTeamEnabled;
